import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom';
import Slider from 'react-slick';
import publicApi from '../services/public.api';

const NewArrivalTwo = ({ productId, categoryId }) => {
    const [products, setProducts] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchRelatedProducts = async () => {
            try {
                if (productId) {
                    const response = await publicApi.getRelatedProducts(productId);
                    if (response.success && response.data) {
                        setProducts(response.data);
                    }
                }
            } catch (error) {
                console.error('Error fetching related products:', error);
            } finally {
                setLoading(false);
            }
        };

        fetchRelatedProducts();
    }, [productId, categoryId]);

    function SampleNextArrow(props) {
        const { className, onClick } = props;
        return (
            <button
                type="button" onClick={onClick}
                className={` ${className} slick-next slick-arrow flex-center rounded-circle border border-gray-100 hover-border-main-600 text-xl hover-bg-main-600 hover-text-white transition-1`}
            >
                <i className="ph ph-caret-right" />
            </button>
        );
    }
    function SamplePrevArrow(props) {
        const { className, onClick } = props;

        return (

            <button
                type="button"
                onClick={onClick}
                className={`${className} slick-prev slick-arrow flex-center rounded-circle border border-gray-100 hover-border-main-600 text-xl hover-bg-main-600 hover-text-white transition-1`}
            >
                <i className="ph ph-caret-left" />
            </button>
        );
    }
    const settings = {
        dots: false,
        arrows: products.length > 1,
        infinite: products.length > 6,
        speed: 1000,
        slidesToShow: 6,
        slidesToScroll: 1,
        initialSlide: 0,
        nextArrow: <SampleNextArrow />,
        prevArrow: <SamplePrevArrow />,
        responsive: [
            {
                breakpoint: 1599,
                settings: {
                    slidesToShow: 6,
                },
            },
            {
                breakpoint: 1399,
                settings: {
                    slidesToShow: 4,
                },
            },
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 3,
                },
            },
            {
                breakpoint: 575,
                settings: {
                    slidesToShow: 2,
                },
            },
            {
                breakpoint: 424,
                settings: {
                    slidesToShow: 1,
                },
            },
        ],
    };

    // Get image URL
    const getImageUrl = (imagePath) => {
        if (!imagePath) return 'assets/images/thumbs/product-img7.png';
        if (imagePath.startsWith('http')) return imagePath;
        
        const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000/api';
        const storageBaseUrl = API_BASE_URL.replace('/api', '');
        
        // Check if path already starts with /storage/ to avoid double prefix
        if (imagePath.startsWith('/storage/')) return `${storageBaseUrl}${imagePath}`;
        if (imagePath.startsWith('storage/')) return `${storageBaseUrl}/${imagePath}`;
        return `${storageBaseUrl}/storage/${imagePath}`;
    };

    // Format price
    const formatPrice = (price) => {
        return parseFloat(price || 0).toFixed(2);
    };

    // Render badge - Yellow with % if has discount, else "Nouveau"
    const renderBadge = (product) => {
        if (product.has_offer && product.discount > 0) {
            return (
                <span 
                    className="product-card__badge px-8 py-4 text-sm new-arrival-badge"
                    style={{ backgroundColor: '#eab802', color: '#000' }}
                >
                    -{product.discount}%
                </span>
            );
        }
        return (
            <span className="product-card__badge bg-info-600 px-8 py-4 text-sm text-white new-arrival-badge">
                Nouveau
            </span>
        );
    };

    if (loading) {
        return (
            <section className="new-arrival pb-80">
                <div className="container container-lg">
                    <div className="section-heading">
                        <h5 className="mb-0">Vous Pourriez Aussi Aimé</h5>
                    </div>
                    <div className="text-center py-5">
                        <div className="spinner-border text-primary" role="status">
                            <span className="visually-hidden">Chargement...</span>
                        </div>
                    </div>
                </div>
            </section>
        );
    }

    if (products.length === 0) {
        return null; // Don't show section if no related products
    }

    return (
        <section className="new-arrival pb-80">
            <div className="container container-lg">
                <div className="section-heading">
                    <div className="flex-between flex-wrap gap-8">
                        <h5 className="mb-0">Vous Pourriez Aussi Aimé</h5>
                        <div className="flex-align mr-point gap-16">
                            <Link
                                to="/shop"
                                className="text-sm fw-medium text-gray-700 hover-text-main-600 hover-text-decoration-underline"
                            >
                                Tous les Produits
                            </Link>
                        </div>
                    </div>
                </div>
                <div className="new-arrival__slider arrow-style-two">
                    <Slider {...settings}>
                        {products.map((product) => (
                            <div key={product.id}>
                                <div className="product-card h-100 p-8 border border-gray-100 hover-border-main-600 rounded-16 position-relative transition-2 new-arrival-product-card">
                                    {renderBadge(product)}
                                    <Link
                                        to={`/product-details/${product.id}`}
                                        className="product-card__thumb flex-center"
                                    >
                                        <img 
                                            src={getImageUrl(product.image)} 
                                            alt={product.name}
                                            style={{ maxHeight: '150px', objectFit: 'contain' }}
                                        />
                                    </Link>
                                    <div className="product-card__content p-sm-2">
                                        <h6 className="title text-lg fw-semibold mt-12 mb-8">
                                            <Link 
                                                to={`/product-details/${product.id}`} 
                                                className="link text-line-2 new-arrival-product-name"
                                            >
                                                {product.name}
                                            </Link>
                                        </h6>
                                        <div className="flex-align gap-4">
                                            <span className="text-main-600 text-md d-flex">
                                                <i className="ph-fill ph-storefront" />
                                            </span>
                                            <span className="text-gray-500 text-xs">
                                                Groupe Délices Benkirane
                                            </span>
                                        </div>
                                        <div className="product-card__content mt-12">
                                            <div className="product-card__price mb-8">
                                                {product.has_offer && product.discount > 0 ? (
                                                    <>
                                                        <span className="text-heading text-md fw-semibold">
                                                            {formatPrice(product.discounted_price)} DH 
                                                            <span className="text-gray-500 fw-normal">/Qty</span>
                                                        </span>
                                                        <span className="text-gray-400 text-md fw-semibold text-decoration-line-through ms-2">
                                                            {formatPrice(product.price)} DH
                                                        </span>
                                                    </>
                                                ) : (
                                                    <span className="text-heading text-md fw-semibold">
                                                        {formatPrice(product.price)} DH 
                                                        <span className="text-gray-500 fw-normal">/Qty</span>
                                                    </span>
                                                )}
                                            </div>
                                            <div className="flex-align gap-6">
                                                <span className="text-xs fw-bold text-gray-600">
                                                    {parseFloat(product.rating_average || 0).toFixed(1)}
                                                </span>
                                                <span className="text-15 fw-bold text-warning-600 d-flex">
                                                    <i className="ph-fill ph-star" />
                                                </span>
                                                <span className="text-xs fw-bold text-gray-600">
                                                    ({product.rating_count || 0})
                                                </span>
                                            </div>
                                            <Link
                                                to="/cart"
                                                className="product-card__cart btn bg-main-50 text-main-600 hover-bg-main-600 hover-text-white py-11 px-24 rounded-pill flex-align gap-8 mt-24 w-100 justify-content-center new-arrival-add-cart-btn"
                                            >
                                                Ajouter au Panier <i className="ph ph-shopping-cart" />
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </Slider>
                </div>
            </div>
        </section>
    )
}

export default NewArrivalTwo